import { useUsers } from "../../api/hooks.ts";
import { shortOwnerId, useOwnerId } from "./owner.ts";
import { usePermissions } from "./permissions.ts";

/**
 * COMO SE LLAMA EL DUENO de la bitacora que se esta mirando.
 *
 * Hace falta en los sitios que firmaban con el usuario de la SESION —la
 * cabecera de una nota, la cinta— y que, mirando la de otro, pondrian el nombre
 * de quien mira sobre lo que escribio otro. El `NoteDto` no trae autor, porque
 * hasta el ADR 0005 solo habia uno; el autor es el dueno.
 *
 * El nombre sale del listado de usuarios, que solo puede pedir un
 * Administrador; para un Mentor lo unico que se sabe del dueno es su
 * identificador, y eso es lo que se ensena. La peticion no se hace si no hay
 * otro dueno que nombrar.
 */
export function useOwnerLabel(): { viewingOther: boolean; label: string; initials: string } {
  const ownerId = useOwnerId();
  const { user: me, isAdministrator } = usePermissions();
  const users = useUsers(isAdministrator && ownerId !== undefined);

  if (ownerId === undefined) {
    return {
      viewingOther: false,
      label: me?.displayName ?? "Tu bitacora",
      initials: me?.displayName ?? "",
    };
  }

  const owner = users.data?.find((item) => item.id === ownerId);

  return {
    viewingOther: true,
    label: owner?.displayName ?? shortOwnerId(ownerId),
    /* Sin nombre no hay iniciales que valgan: `initials("")` pinta el
       marcador generico del avatar. */
    initials: owner?.displayName ?? "",
  };
}
